import { render, staticRenderFns } from "./wiki-panel.vue?vue&type=template&id=9c8e75b6"
import script from "./wiki-panel.vue?vue&type=script&lang=js"
export * from "./wiki-panel.vue?vue&type=script&lang=js"
import style0 from "./wiki-panel.vue?vue&type=style&index=0&id=9c8e75b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports